import type MarkdownIt from 'markdown-it'
import type Token from 'markdown-it/lib/token.mjs'

/** Mark quoted speech without changing source text or crossing HTML boundaries. */
export function configureStoryDialogue(renderer: MarkdownIt): void {
  renderer.core.ruler.before('text_join', 'story_dialogue', (state) => {
    if (!state.env.storyDialogue) return

    for (const block of state.tokens) {
      if (block.type !== 'inline' || !block.children) continue
      const children: Token[] = []
      // Reset at paragraph/block boundaries, including an unfinished streamed quote.
      let quote: '"' | '“' | null = null
      let emphasisDepth = 0

      const appendText = (content: string, dialogue: boolean) => {
        if (!content) return
        const text = new state.Token('text', '', 0)
        text.content = content
        if (dialogue && emphasisDepth === 0) {
          const open = new state.Token('story_dialogue_open', 'span', 1)
          open.attrSet('class', 'story-dialogue')
          children.push(open, text, new state.Token('story_dialogue_close', 'span', -1))
        } else {
          children.push(text)
        }
      }

      for (const token of block.children) {
        if (token.type === 'em_open') emphasisDepth++
        if (token.type === 'em_close') emphasisDepth--
        if (token.type === 'text_special') {
          // Escaped punctuation and entities are literal, never quote boundaries.
          appendText(token.content, quote !== null)
        } else if (token.type === 'text') {
          let start = 0
          for (let index = 0; index < token.content.length; index++) {
            const char = token.content[index]
            if (quote === null && (char === '"' || char === '“')) {
              appendText(token.content.slice(start, index), false)
              start = index
              quote = char
            } else if ((quote === '"' && char === '"') || (quote === '“' && char === '”')) {
              appendText(token.content.slice(start, index + 1), true)
              start = index + 1
              quote = null
            }
          }
          appendText(token.content.slice(start), quote !== null)
        } else {
          // Formatting stays intact; code contents and link destinations are untouched.
          children.push(token)
        }
      }
      block.children = children
    }
  })
}
